<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-8 mb-1">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Company Name, Email"
              aria-label="Company Name, Email"
              aria-describedby="Company Name, Email"
              v-model="search_text"
            />
            <div class="input-group-append">
              <button class="btn btn-info" type="button" @click="getPendingEmployers(1)">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive" style="min-height:300px;">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark': ''"
        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
        tbody-classes="list"
        :data="pendingEmployers"
      >
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Company Name</th>
          <th class="text-center">Email</th>
          <th class="text-center">Contact Person</th>
          <th class="text-center">Contact No.</th>
          <th class="text-center">Applied Date</th>
          <th class="text-center">Status</th>
          <th></th>
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.company_name}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.email_address}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.contact_person}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.contact_number}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.applied_date}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm" v-if="row.status == 0">Pending</span>
                <span class="name mb-0 text-sm text-success" v-if="row.status == 1">Approved</span>
                <span class="name mb-0 text-sm text-danger" v-if="row.status == 2">Rejected</span>
              </div>
            </div>
          </td>

          <td class="text-right">
            <base-dropdown class="dropdown" position="right">
              <a
                slot="title"
                class="btn btn-sm btn-icon-only text-light"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" @click="openPendingEmployerModal(row.id)">Update</a>
              </template>
            </base-dropdown>
          </td>
        </template>
      </base-table>
    </div>

    <div class="row" id="div-edit-employers-profile">
      <div class="col-md-4">
        <modal
          :show.sync="modals.admin_profile_modal"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">ADMIN PROFILE</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div>
                    <tabs fill class="flex-column flex-md-row">
                      <card shadow>
                        <tab-pane title="Info">
                          <span slot="title">Info</span>

                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Company Name:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Company Name"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Reg. No.:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Reg. No."
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Industry:</div>
                            <div class="col-sm-9">
                              <select class="form-control" v-model="employer.industry">
                                <option value>-- Select Industry --</option>
                                <template v-for="(data, key) in industriesList">
                                  <option
                                    v-bind:key="key"
                                    v-bind:value="data.industry_id"
                                  >{{ data.name }}</option>
                                </template>
                              </select>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Person In Charge:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Person In Charge"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Contact No.:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Contact No."
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Email Address:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Email Address"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Website:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Email Address"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3">Is Anonymous:</div>
                            <div class="col-sm-9">
                              <base-checkbox class="mb-3"></base-checkbox>
                            </div>
                          </div>
                        </tab-pane>

                        <tab-pane title="Additional">
                          <span slot="title">Additional</span>

                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Dress Code:</div>
                            <div class="col-sm-9">
                              <select class="form-control" v-model="employer.dressCode">
                                <option value>-- Select Dress Code --</option>
                                <template v-for="(data, key) in dressCodesList">
                                  <option
                                    v-bind:key="key"
                                    v-bind:value="data.dress_code_id"
                                  >{{ data.name }}</option>
                                </template>
                              </select>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Company Size:</div>
                            <div class="col-sm-9">
                              <select class="form-control" v-model="employer.companySize">
                                <option value>-- Select Company Size --</option>
                                <template v-for="(data, key) in companySizesList">
                                  <option
                                    v-bind:key="key"
                                    v-bind:value="data.industry_id"
                                  >{{ data.name }}</option>
                                </template>
                              </select>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Working Hours:</div>
                            <div class="col-sm-4">
                              <base-input
                                alternative
                                placeholder="Start"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                            <div class="col-sm-1 col-form-label">-</div>
                            <div class="col-sm-4">
                              <base-input
                                alternative
                                placeholder="Emd"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Spoken Language:</div>
                            <div class="col-sm-9">
                              <base-input>
                                <select class="form-control" multiple>
                                  <option value>-- Select Spoken Language --</option>
                                  <template v-for="(data, key) in spokenLanguagesList">
                                    <option
                                      v-bind:key="key"
                                      v-bind:value="data.language_id"
                                    >{{ data.name }}</option>
                                  </template>
                                </select>
                              </base-input>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Overview:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Overview"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                        </tab-pane>

                        <tab-pane title="Address">
                          <span slot="title">Address</span>

                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Line 1:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Line 1"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Line 2:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Line 2"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Town:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Town"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Postal Code:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Postal Code"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Country:</div>
                            <div class="col-sm-9">
                              <select
                                class="form-control"
                                v-model="employer.country"
                                v-on:change="getStates()"
                              >
                                <option value>-- Select Country --</option>
                                <template v-for="(data, key) in countries">
                                  <option
                                    v-bind:key="key"
                                    v-bind:value="data.country_id"
                                  >{{ data.name }}</option>
                                </template>
                              </select>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">State:</div>
                            <div class="col-sm-9">
                              <select class="form-control">
                                <option value>-- Select State --</option>
                                <template v-for="(data, key) in states">
                                  <option
                                    v-bind:key="key"
                                    v-bind:value="data.state_id"
                                  >{{ data.name }}</option>
                                </template>
                              </select>
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Latitude:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Latitude"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">Longitude:</div>
                            <div class="col-sm-9">
                              <base-input
                                alternative
                                placeholder="Longitude"
                                input-classes="form-control-alternative"
                                type="text"
                              />
                            </div>
                          </div>
                        </tab-pane>

                        <tab-pane title="Photos">
                          <div class="row">
                            <div class="col-sm-3">Skills:</div>
                            <div class="col-sm-9"></div>
                          </div>
                        </tab-pane>

                        <tab-pane title="Banner">
                          <span slot="title">Banner</span>

                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                        </tab-pane>

                        <tab-pane title="Logo">
                          <span slot="title">Logo</span>

                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                        </tab-pane>

                        <tab-pane title="Credential">
                          <span slot="title">Credential</span>

                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Resume:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Expected Salary:</div>
                            <div class="col-sm-9"></div>
                          </div>
                          <div class="row">
                            <div class="col-sm-3">Languages:</div>
                            <div class="col-sm-9"></div>
                          </div>
                        </tab-pane>
                      </card>
                    </tabs>
                  </div>
                  <div class="text-center">
                    <base-button
                      type="danger"
                      class="my-4"
                      @click="modals.admin_profile_modal = false"
                    >Cancel</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <div class="row" id="div-account-approval-modal">
      <div class="col-md-4">
        <modal
          :show.sync="modals.account_approval_modal"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">PENDING APPROVAL</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div class="container-fluid">
                    <div class="row mb-lg-4">
                      <div class="col-lg-3">Company Name:</div>
                      <div class="col-lg-9">{{ pendingEmployer.companyName }}</div>
                    </div>
                    <div class="row mb-lg-4">
                      <div class="col-lg-3">Contact Person:</div>
                      <div class="col-lg-9">{{ pendingEmployer.pic }}</div>
                    </div>
                    <div class="row mb-lg-4">
                      <div class="col-lg-3">Contact No.:</div>
                      <div class="col-lg-9">{{ pendingEmployer.contactNo }}</div>
                    </div>
                    <div class="row mb-lg-4">
                      <div class="col-lg-3">Email:</div>
                      <div class="col-lg-9">{{ pendingEmployer.loginEmail }}</div>
                    </div>
                    <div class="row mb-lg-4">
                      <div class="col-lg-3">Industry:</div>
                      <div class="col-lg-9">{{ pendingEmployer.industry }}</div>
                    </div>
                    <div class="row mb-lg-4">
                      <div class="col-lg-3">Address:</div>
                      <div class="col-lg-9">{{ pendingEmployer.address }}</div>
                    </div>
                    <div class="row mb-lg-4">
                      <div class="col-lg-3">Is Anonymous:</div>
                      <div class="col-lg-9">{{ pendingEmployer.isAnonymous }}</div>
                    </div>
                    <div class="row mb-lg-4">
                      <div class="col-lg-3">Applied Date:</div>
                      <div class="col-lg-9">{{ pendingEmployer.appliedDate }}</div>
                    </div>
                  </div>
                  <div class="text-center">
                    <base-button
                      type="danger"
                      class="my-4"
                      @click="updateStatus(pendingEmployer.companyId, 2)"
                    >Reject</base-button>
                    <base-button
                      type="success"
                      class="my-4"
                      @click="updateStatus(pendingEmployer.companyId, 1)"
                    >Approve</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent': ''"
    >
      <base-pagination :perPage="10" :total="totalJobApplications" :value="pageNumber"></base-pagination>
    </div>
  </div>
</template>
<script>
import EventBus from "./../../event-bus";

export default {
  name: "pending-employers-table",
  props: {
    type: {
      type: String
    },
    title: String
  },
  data() {
    return {
      totalJobApplication: 10,
      search_text: "",
      employer: {
        companyName: "",
        companyReg: "",
        industry: "",
        pic: "",
        contactNo: "",
        emailAddress: "",
        website: "",
        isAnonymous: false,
        dressCode: "",
        companySize: "",
        workingHoursStart: "",
        workingHoursEnd: "",
        spokenLanguage: "",
        overview: "",
        line1: "",
        line2: "",
        town: "",
        postalCode: "",
        state: "",
        country: "",
        latitude: 0.0,
        longitude: 0.0,
        loginEmail: "",
        password: "",
        confirmedPassword: ""
      },
      pendingEmployer: {
        companyId: 0,
        companyName: "",
        pic: "",
        contactNo: "",
        loginEmail: "",
        industry: "",
        address: "",
        isAnonymous: false,
        appliedDate: ""
      },
      ipt_country: "",
      modals: {
        admin_profile_modal: false,
        account_approval_modal: false
      }
    };
  },
  computed: {
    pendingEmployers() {
      return this.$store.getters.pendingEmployers;
    },
    countries() {
      return this.$store.getters.countries;
    },
    states() {
      return this.$store.getters.states;
    },
    dressCodesList() {
      return this.$store.getters.dressCodesList;
    },
    industriesList() {
      return this.$store.getters.industriesList;
    },
    companySizesList() {
      return this.$store.getters.companySizesList;
    },
    spokenLanguagesList() {
      return this.$store.getters.spokenLanguagesList;
    },
    pageNumber() {
      return parseInt(this.$route.query.page);
    },
    totalJobApplications() {
      return this.totalJobApplication;
    }
  },
  watch: {
    pageNumber() {
      this.getPendingEmployers(this.$route.query.page);
    }
  },
  mounted() {
    this.getPendingEmployers(1);
    this.getTotalJobApplication();
    this.getCountries();
    this.getDressCodes();
    this.getIndustries();
    this.getCompanySizes();
    this.getSpokenLanguages();
  },
  methods: {
    getPendingEmployers: function(page_number) {
      this.$store
        .dispatch('fetchEmployers', 
        {
          keyword: this.search_text,
          page : page_number, 
          status : 0
        })
        .then(response => {
          const { data, meta } = response.data;
          this.totalJobApplication = meta.total_result;
          this.$router.push({ query: { page: page_number } });
          this.$store.dispatch("updateState", {
            key: "pendingEmployers",
            value: data
          });
        });
    },

    getPendingEmployer: function(company_id) {
      this.$store
        .dispatch("fetchPendingEmployer", {
          id: parseInt(company_id)
        })
        .then(response => {
          let responseData = response.data;
          this.pendingEmployer.companyId = company_id;
          this.pendingEmployer.companyName = responseData.company_name;
          this.pendingEmployer.pic = responseData.pic;
          this.pendingEmployer.contactNo = responseData.contact_number;
          this.pendingEmployer.loginEmail = responseData.email_address;
          this.pendingEmployer.industry = responseData.industry;
          this.pendingEmployer.address = responseData.address;
          this.pendingEmployer.isAnonymous =
            responseData.is_anonymous == 1 ? "Yes" : "No";
          this.pendingEmployer.appliedDate = responseData.applied_date;
        });
    },

    openPendingEmployerModal: function(company_id) {
      this.modals.account_approval_modal = true;
      this.getPendingEmployer(company_id);
    },

    updateStatus(company_id, status) {
      this.$store
        .dispatch("updateEmployerStatus", {
          id: company_id,
          status: status
        })
        .then(response => {
          if (response.data.error == "1000") {
            this.modals.account_approval_modal = false;
            this.getPendingEmployers(this.$route.query.page);
            EventBus.$emit("updatePendingEmployerCount");
            EventBus.$emit("updateEmployerCount");
          }
        });
    },

    getCountries() {
      this.$store.dispatch("fetchCountries").then(response => {
        this.$store.dispatch("updateState", {
          key: "countries",
          value: response.data
        });
      });
    },

    getStates: function() {
      this.$store
        .dispatch("fetchStates", {
          country_id: this.employer.country
        })
        .then(response => {
          this.$store.dispatch("updateState", {
            key: "states",
            value: response.data
          });
        });
    },

    getDressCodes: function() {
      this.$store.dispatch("fetchDressCodesList").then(response => {
        this.$store.dispatch("updateState", {
          key: "dressCodesList",
          value: response.data
        });
      });
    },

    getIndustries: function() {
      this.$store.dispatch("fetchIndustriesList").then(response => {
        this.$store.dispatch("updateState", {
          key: "industriesList",
          value: response.data
        });
      });
    },

    getCompanySizes: function() {
      this.$store.dispatch("fetchCompanySizesList").then(response => {
        this.$store.dispatch("updateState", {
          key: "companySizesList",
          value: response.data
        });
      });
    },

    getSpokenLanguages: function() {
      this.$store.dispatch("fetchSpokenLanguagesList").then(response => {
        this.$store.dispatch("updateState", {
          key: "spokenLanguagesList",
          value: response.data
        });
      });
    },

    openModal() {
      this.modals.admin_profile_modal = true;
    },

    getTotalJobApplication() {
      this.$store
        .dispatch("fetchTotalEmployer", { status: 0 })
        .then(response => {
          this.totalJobApplication = parseInt(response.data);
        });
    }
  }
};
</script>
<style>
</style>
